<template>
  <div class="canvas-status" v-if="$root.message !== ''">
    <span
      class="canvas-status-text"
      :class="$root.messageColor"
      v-html="formattedMessage"
    />
  </div>
</template>

<script>
export default {
  name: 'WebGlStatus',
  props: {},
  data() {
    return {
      interval: null,
    };
  },
  methods: {},
  computed: {
    formattedMessage() {
      return this.$root.message.split('').map((char) => `<span>${char}</span>`).join('');
    },
  },
  mounted() {
  },
  watch: {
    '$root.message': function () {
      const self = this;
      if (this.interval) {
        window.clearInterval(this.interval);
      }
      this.interval = window.setInterval(() => {
        self.$root.message = '';
      }, 4000);
    },
  },
};
</script>

<style scoped lang="scss">
.canvas-status {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-top: 1.5rem;
  margin-right: 1rem;
  padding: 0.5rem;
  border-radius: 12px;
}

.canvas-status-text {
  color: black;
  font-size: x-large;
  font-weight: 600;
  font-family: monospace;
}

.canvas-status-text > span {
  display: inline-block;
  width: 12px;
  text-align: center;
}

.white {
  color: #ffffff;
}

.black {
  color: #000000;
}
</style>
